import React from 'react';
import styles from './ContentCard.module.scss';
import { useEffect } from "react";
import { useState } from "react";
import { Col, Card, Placeholder } from "react-bootstrap";
import notFoundAH from "images/backgrounds/not_found.png";
import notFoundLib from "images/backgrounds/DefaultCover.svg";
import ApiURLs from "config/ApiURLs";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

export default function ContentCard(props) {
    //console.log("props",props);
    const { title, blurb, image, id } = props.data;
    const [recordData, setRedordData] = useState({});
    const [loading, setLoading] = useState({ img: true, data: true });
    const [notFoundImage, setNotFoud] = useState("");

    useEffect(() => {
        function getImage(element) {
            if (!element?.thumbnail) {
                return notFoundImage;
            }
            if (element.thumbnail === "NULL") {
                return notFoundImage;
            }
            return element.thumbnail;
        }
        function getUrlPath(element, whitDomain = false) {
            /* if (element.contenttype === "page") {
              return ApiURLs.cirmaDomainName + element.id.substring(1);
            }
            if (element.contenttype === "news") {
              return ApiURLs.cirmaDomainName+ "noticia/" + element.id;
            }
            if (element?.repository === "CIRMA-BIB") {
              return whitDomain
                ? ApiURLs.libraryDomainName + "opac/record/" + element.id
                : "opac/record/" + element.id;
            }
            if (element?.contenttype === "library") {
              return whitDomain
                ? ApiURLs.libraryDomainName + "opac/record/" + element.id
                : "opac/record/" + element.id;
            }
            return whitDomain
              ? ApiURLs.cirmaDomainName + "glifos/item/" + element.id
              : "glifos/item/" + element.id; */
            if (element.contenttype === "web_exhibit") {
                return element.id;
            }
            return ApiURLs.tamiDomainName + element.id;
        }
        var temData = props?.data;
        if (Array.isArray(temData?.authors)) {
            temData.authors = temData?.authors[0];
        }
        temData.urlPath = getUrlPath(temData, true);
        temData.thumbnail = getImage(temData, true);

        setRedordData(temData);
        setLoading({ data: false });
        if (props?.data?.contenttype === "item") {
            setNotFoud(notFoundAH);
        } else if (props?.data?.contenttype === "library") {
            setNotFoud(notFoundLib);
        } else {
            setNotFoud(notFoundAH);
        }
    }, [notFoundImage, props?.data]);

    function proccessImage(image) {
        let imageP = image;
        if (image?.includes("api/glifos/glifos/file/get///default/sites/default/files/styles/large/public") === true) {
            imageP = image.replace("api/glifos/glifos/file/get///default/sites/default/files/styles/large/public", "api/glifos/sites/default/files");
        } else if (image?.includes("api/glifos//default/sites/default/files/styles/large/public") === true) {
            imageP = image.replace("api/glifos//default/sites/default/files/styles/large/public", "api/glifos/sites/default/files");
        } else if (image?.includes("/glifos/glifos/file/get//sites/default/files/") === true) {
            imageP = image.replace("/glifos/glifos/file/get//sites/default/files/", "/glifos/sites/default/files/");
        } else if (image?.includes("/glifos/sites/default/files/styles/large/public/") === true) {
            imageP = image.replace("/glifos/sites/default/files/styles/large/public/", "/glifos/sites/default/files/");
        } else if (image?.includes(window.location.hostname + "/api/glifos/" + window.location.hostname) === true) {
            imageP = image.replace(window.location.hostname + "/api/glifos/" + window.location.hostname, window.location.hostname);
        }

        return imageP;
    }

    /* const navigate = useNavigate(); */
    //console.log("title",title);

    return (
        <Col lg={6}>
            {!loading.data && (
                <a href={recordData.urlPath}>
                    <div className={`${styles.card}`}>
                        <div className={`${styles.image}`}>
                            <LazyLoadImage
                                className="card-img-top cont"
                                alt={props.data?.id}
                                src={proccessImage(ApiURLs.ApiUrl + props.data?.thumbnail)} // use normal
                                effect="blur"
                                delayTime={1}
                                onError={({ currentTarget }) => {
                                    currentTarget.onerror = null; // prevents looping
                                    currentTarget.src = notFoundImage;
                                }}
                            />
                            {/* <img src={image} alt="content"/> */}
                        </div>
                        <div className={`${styles.content}`}>
                            <div className={`${styles.title}`}>
                                {title.replace('$pipe', '|')
                                .replace('&a...', '&...')}
                            </div>
                            <div className={`${styles.description}`}>
                                {blurb}
                            </div>
                        </div>

                    </div>
                </a>)}
        </Col>
    )
}
